import { configureStore } from '@reduxjs/toolkit'
import bucketReducer from '../components/buckets/slice/buckets'
import timeCounterSlice from '../components/session/features/sessionWatch/sessionWatchSlice'
import mind2Reducer from '../components/mind-2/slice/mindSlice2'
import riskRegisterReducer from '../components/riskRegister/riskRegisterSlice'

export default configureStore({
  reducer: {
    bucketList: bucketReducer,
    timeCounter: timeCounterSlice,
    mind2: mind2Reducer,
    riskRegister: riskRegisterReducer
  },

})